// created from 'create-ts-index'

export * from './AgreeTerms';
export * from './components';
export * from './Privacy';
export * from './Terms';
